import { render, staticRenderFns } from "./fieldVsCheckbox.vue?vue&type=template&id=67a68121&"
import script from "./fieldVsCheckbox.vue?vue&type=script&lang=js&"
export * from "./fieldVsCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports